import axiosInstance from "../axiosInstance";

export const getFollowers = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/followers/users/${userId}/followers`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching followers:", error);
    return [];
  }
};

export const getFollowing = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `/api/v1/followers/users/${userId}/following`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching following:", error);
    return [];
  }
};

export const isFollowing = async (userId) => {
  if (!userId) {
    console.error("User ID is missing.");
    return false;
  }

  try {
    const response = await axiosInstance.get(
      `/api/v1/followers/users/${userId}/is-following`
    );
    console.log("API Response for isFollowing:", response.data);
    return response.data === true;
  } catch (error) {
    console.error("Error fetching follow status:", error);
    return false;
  }
};

export const followUser = async (userId) => {
  if (!userId) {
    console.error("User ID is missing.");
    return false;
  }
  try {
    const response = await axiosInstance.post(
      `/api/v1/followers/users/${userId}`
    );
    return response.status === 200;
  } catch (error) {
    console.error("Error following user:", error);
    return false;
  }
};

export const unfollowUser = async (userId) => {
  if (!userId) {
    console.error("User ID is missing.");
    return false;
  }
  try {
    const response = await axiosInstance.delete(
      `/api/v1/followers/users/${userId}`
    );
    return response.status === 200;
  } catch (error) {
    console.error("Error unfollowing user:", error);
    return false;
  }
};
